/* BI-07 · INVOICES
   Compliant PDFs and a payment portal that cannot switch to the 3-year
   contract or apply promo codes. */
import { Button, Pill } from '@/ui'
import { Head, useBill } from './ParamShell'

export default function BI07Factures() {
  const inv = useBill().invoices
  return (
    <section data-frame="BI-07" style={{ display: 'grid', gap: 14 }}>
      <Head title="Factures" end={<Button variant="quiet" size="sm">Portail de paiement</Button>} />
      <div className="tablewrap">
        <table className="tbl">
          <thead><tr><th>Date</th><th>N°</th><th>Montant</th><th>État</th></tr></thead>
          <tbody>
            {inv.map(i => (
              <tr key={i.number}>
                <td>{i.date}</td><td>{i.number}</td><td>{i.amount}</td>
                <td><Pill tone={i.status.tone} mark={i.status.mark}>{i.status.label}</Pill></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <p className="t-body">
        PDF conformes (numérotation, mentions) · portail : carte, fréquence, historique — sans
        bascule 3 ans ni codes promo.
      </p>
    </section>
  )
}
